import { UserManager, WebStorageStateStore } from 'oidc-client-ts';

// Exported separately so other code that needs to talk to Authentik
// directly — not through oidc-client-ts — can reuse the same value
// instead of duplicating it. See SsoSyncCallback.jsx's own token
// exchange for the reason that exists.
//
// CONFIRMED BUG (2026-08-11): this used to be the human-readable slug
// ('bescom-sso-portal'), not the actual Authentik-issued Client ID —
// harmless as long as nothing here actually sent it to Authentik, which
// was true until logout()'s signoutRedirect() became the first real
// caller, and Authentik rejected it outright ("Bad Request — the
// request is otherwise malformed") for referencing an unknown client.
// The real value lives on the sso-portal-provider's own Overview page
// in Authentik (Applications -> Providers -> sso-portal-provider).
export const SSO_PORTAL_CLIENT_ID = 'GZp3B9Q4ZiVqin0ahBBAmUVRhmZvvH4R3sXGNuew';

const userManager = new UserManager({
  authority: process.env.REACT_APP_AUTHENTIK_AUTHORITY,
  client_id: SSO_PORTAL_CLIENT_ID,
  redirect_uri: process.env.REACT_APP_REDIRECT_URI,
  post_logout_redirect_uri: process.env.REACT_APP_POST_LOGOUT_URI,
  response_type: 'code',
  scope: 'openid profile email groups',
  loadUserInfo: false,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  stateStore: new WebStorageStateStore({ store: window.localStorage }),
});

export default userManager;